module.exports = __webpack_public_path__ + "dk.d6e726a8f9151fa11244.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/dk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/dk.svg
// module chunks = styles